import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { firebaseApp, getVersion } from '../../Firebase'
import userInfo from '../../utils/userInfo'
import Header from '../AppHeader'
import PlainHeader from '../AppHeader/PlainHeader'
import Login from '../UserLogin'
import User from '../User'
import UserAccount from '../UserAccount'
import Home from '../../pages/Home'
import asyncComponent from '../../asyncComponent'
import './index.css'

const asyncDb = asyncComponent(() => import('../Db'))
const asyncExportImport = asyncComponent(() => import('../ExportImport'))
const asyncTry = asyncComponent(() => import('../../pages/Try'))
const asyncAbout = asyncComponent(() => import('../../pages/About'))
const zou1 = asyncComponent(() => import('../../pages/Doc/Zou1'))
const zou2 = asyncComponent(() => import('../../pages/Doc/Zou2'))
const op1 = asyncComponent(() => import('../../pages/Doc/Op1'))
const asyncSanbox = asyncComponent(() => import('../../sandbox'))
const asyncChromeStore = asyncComponent(() => import('../../pages/ChromeStore'))
const asyncXjskDev = asyncComponent(() => import('../../pages/Xjskdef'))

class App extends React.Component {
  constructor (props) {
    super(props)
    this.setAuthStateChecker = this.setAuthStateChecker.bind(this)
  }

  componentDidMount () {
    getVersion(version =>{
      if (version !== process.env.REACT_APP_VERSION) {
        window.location.reload()
      }
    })
    setTimeout(() => {
      this.setAuthStateChecker()
    }, 100)
  }

  setAuthStateChecker () {
    firebaseApp.auth().onAuthStateChanged((user) => {
      if (user) {
        if (!user.ddpLo) {
          this.props.onAuthStateChanged(userInfo(user))
        }
      } else {
        this.props.onAuthStateChanged(null)
      }
    })
  }

  render () {
    if (this.props.location.pathname.indexOf('/doc/') !== - 1) {
      return (
        <React.Fragment>
          <PlainHeader />
          <Switch>
            <Route exact path='/doc/zou1' component={zou1} />
            <Route exact path='/doc/zou2' component={zou2} />
            <Route exact path='/doc/op1' component={op1} />
          </Switch>
        </React.Fragment>
      )
    }
    return (
      <React.Fragment>
        <Header />
        <div className='app'>
          <Switch>
            <Route exact path='/' component={Home} />
            <Route path='/login' component={Login}/>
            <Route path='/user' component={User}/>
            <Route path='/account' component={UserAccount}/>
            <Route path='/db' component={asyncDb}/>
            <Route path='/csvi' component={asyncExportImport}/>
            <Route path='/try' component={asyncTry}/>
            <Route path='/about' component={asyncAbout}/>
            <Route path='/sandbox' component={asyncSanbox}/>
            <Route path='/chs' component={asyncChromeStore}/>
            <Route path='/xjskdev' component={asyncXjskDev}/>
          </Switch>
        </div>
      </React.Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/indexC.js